import { required, maxLength } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    diaMes: { required },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Nome é obrigatório.')
    !this.$v.form.description.maxLength && errors.push('Nome não pode conter mais de 30 caracteres.')
    return errors
  },
  diaMesErrors() {
    const errors = []
    if (!this.$v.form.diaMes.$dirty) return errors
    !this.$v.form.diaMes.required && errors.push('Este campo é obrigatório.')
    return errors
  },
}
